import type { TilePosition } from '../model/gamestate/GameState';

export const SKILL_TARGETING_STATE_EVENT = 'skill:targetingState';

export interface SkillTargetCandidate {
  targetType: 'tile' | 'entity';
  actorId?: string;
  kind?: 'remotePlayer' | 'mob' | 'self';
  displayName: string;
  position: TilePosition;
}

export interface SkillTargetingState {
  active: boolean;
  skillId: string | null;
  requiredSlots: number;
  slotTypes: Array<'tile' | 'entity'>;
  hovered: SkillTargetCandidate | null;
  selected: Array<SkillTargetCandidate | null>;
}

